import React from "react"
import loadable from "@loadable/component"
import * as Adm from "@adm"

const loadingKit = {}

// Guards
const SignIn = loadable(() => import("../pages/auth/SignIn"), loadingKit)
const SignUp = loadable(() => import("../pages/auth/SignUp"), loadingKit)
const ResetPassword = loadable(
  () => import("../pages/auth/ResetPassword"),
  loadingKit
)
const Page404 = loadable(() => import("../pages/auth/Page404"), loadingKit)
const Page500 = loadable(() => import("../pages/auth/Page500"), loadingKit)
const Page403 = loadable(() => import("../pages/auth/Page403"), loadingKit)

//SmartConfigRoutes
const GondolaLanding = loadable(
  () => import("../pages/smartDeviceConfig/gondola/LandingPage"),
  loadingKit
)
const Gondola = loadable(
  () => import("../pages/smartDeviceConfig/gondola/index"),
  loadingKit
)
const PlanogramLanding = loadable(
  () => import("../pages/smartDeviceConfig/planogram/LandingPage"),
  loadingKit
)
const Planogram = loadable(
  () => import("../pages/smartDeviceConfig/planogram/index"),
  loadingKit
)
const DeviceConfig = loadable(
  () => import("../pages/smartDeviceConfig/DeviceConfig/index"),
  loadingKit
)
const CameraLanding = loadable(
  () => import("../pages/smartDeviceConfig/camera/LandingPage"),
  loadingKit
)
const Camera = loadable(
  () => import("../pages/smartDeviceConfig/camera/index"),
  loadingKit
)
const SmartshelfLanding = loadable(
  () => import("../pages/smartDeviceConfig/smartShelf/LandingPage"),
  loadingKit
)
const Smartshelf = loadable(
  () => import("../pages/smartDeviceConfig/smartShelf/index"),
  loadingKit
)
const Turnstile = loadable(
  () => import("../pages/smartDeviceConfig/turnstile/index"),
  loadingKit
)
const PaymentReadersLanding = loadable(
  () => import("../pages/smartDeviceConfig/paymentReaders/LandingPage"),
  loadingKit
)
const PaymentReaders = loadable(
  () => import("../pages/smartDeviceConfig/paymentReaders/index"),
  loadingKit
)
const StoreDevicesLanding = loadable(
  () => import("../pages/smartDeviceConfig/storeDevices/LandingPage"),
  loadingKit
)
const StoreDevices = loadable(
  () => import("../pages/smartDeviceConfig/storeDevices/index"),
  loadingKit
)
const StoreConfig = loadable(
  () => import("../pages/smartDeviceConfig/storeConfig/index"),
  loadingKit
)
const inStoreDisplay = loadable(
  () => import("../pages/smartDeviceConfig/inStoreDisplay/index"),
  loadingKit
)

//FSSmartDeviceConfigRoutes
const CameraFS = loadable(
  () => import("../pages/smartDeviceConfig/cameraFS/index"),
  loadingKit
)
const EdgeDeviceFS = loadable(
  () => import("../pages/smartDeviceConfig/edgeDeviceFS/index"),
  loadingKit
)

//Space Planning
const SpacePlanning = loadable(
  () => import("../pages/spacePlanning/PlanogramDetailedView"),
  loadingKit
)
const FrictionlessStore = loadable(
  () => import("../pages/spacePlanning/FrictionlessDetailedView"),
  loadingKit
)
// LIVE_MONTIORING
const SpacePlanningList = loadable(
  // () => import("../pages/transactionBrowser/tenantDetails"),
  () => import("../pages/spacePlanning/spacePlanningList/LandingPage"),
  // () => import("../pages/spacePlanning/spacePlanningList/index"),
  loadingKit
)
const SpacePlanningListTenant = loadable(
  () => import("../pages/spacePlanning/spacePlanningList/index"),
  loadingKit
)
const ForgetPassword = loadable(
  () => import("../pages/auth/ForgetPassword"),
  loadingKit
)
const ProfileUpdate = loadable(
  () => import("../pages/auth/ProfileUpdate"),
  loadingKit
)
const EmployeeDetails = loadable(() =>
  import("../pages/employeeDetails/EmployeeDetails")
)
// Dashboards components
const SassDashboard = loadable(
  () => import("../pages/SassDashboard"),
  loadingKit
)
const PlanogramDetails = loadable(
  () => import("../pages/PlanogramDetails"),
  loadingKit
)
const Dashboard = loadable(() => import("../pages/dashboard"), loadingKit)
const Countries = loadable(
  () => import("../pages/content/countries"),
  loadingKit
)
const USStates = loadable(() => import("../pages/content/usStates"), loadingKit)
const Currencies = loadable(
  () => import("../pages/content/currencies"),
  loadingKit
)
const Gender = loadable(() => import("../pages/content/gender"), loadingKit)
const Digitshelf = loadable(
  () => import("../pages/content/digitShelf"),
  loadingKit
)
const CanadianProvincesList = loadable(() =>
  import("../pages/content/canadianProvincesList")
)
const Languages = loadable(
  () => import("../pages/content/languages"),
  loadingKit
)
const UnitsOfMeasure = loadable(
  () => import("../pages/content/unitsOfMeasure"),
  loadingKit
)
const PaymentGateWayContent = loadable(
  () => import("../pages/content/paymentGateway"),
  loadingKit
)
const ReceiptQR = loadable(
  () => import("../pages/content/ReceiptQR"),
  loadingKit
)
const StoreTypeContent = loadable(
  () => import("../pages/content/storeType"),
  loadingKit
)
const BarcodeTypes = loadable(
  () => import("../pages/content/barcodeTypes"),
  loadingKit
)
const Tax = loadable(() => import("../pages/content/tax"), loadingKit)

const VendorsLanding = loadable(
  () => import("../pages/masterData/vendors/LandingPage"),
  loadingKit
)

const Vendors = loadable(
  () => import("../pages/masterData/vendors"),
  loadingKit
)

const LocationsProductStorageLanding = loadable(
  () => import("../pages/masterData/locationProductStorage/LandingPage"),
  loadingKit
)
const LocationsProductStorage = loadable(
  () => import("../pages/masterData/locationProductStorage"),
  loadingKit
)

const CreateUpdateStorage = loadable(
  () =>
    import("../pages/masterData/locationProductStorage/createUpdateStorage"),
  loadingKit
)

const LocationsLanding = loadable(
  () => import("../pages/masterData/locations/LandingPage"),
  loadingKit
)

const Locations = loadable(
  () => import("../pages/masterData/locations"),
  loadingKit
)

const GroupsLanding = loadable(() =>
  import(
    "../pages/masterData/locations/GroupLocation/GroupLocationsList/LandingPage"
  )
)

const Groups = loadable(() =>
  import("../pages/masterData/locations/GroupLocation/GroupLocationsList")
)

const HierarchyLanding = loadable(
  () => import("../pages/masterData/Hierarchy/LandingPage"),
  loadingKit
)
const Hierarchy = loadable(
  () => import("../pages/masterData/Hierarchy"),
  loadingKit
)

const HierarchyMappingLanding = loadable(
  () => import("../pages/masterData/HierarchyMapping/LandingPage"),
  loadingKit
)
const HierarchyMapping = loadable(
  () => import("../pages/masterData/HierarchyMapping/index"),
  loadingKit
)

const ConfigurePos = loadable(
  () => import("../pages/masterData/locations/ConfigurePos/Pos"),
  loadingKit
)

const CreateNewPos = loadable(
  () => import("../pages/masterData/locations/ConfigurePos/CreatePos/index"),
  loadingKit
)

const PosDetailedScreen = loadable(
  () => import("../pages/masterData/locations/ConfigurePos/PosDetailed/index"),
  loadingKit
)

const ProductAttributeLanding = loadable(
  () => import("../pages/masterData/products/ProductAttribute/LandingPage"),
  loadingKit
)
const ProductAttribute = loadable(
  () => import("../pages/masterData/products/ProductAttribute/index"),
  loadingKit
)

const ProductsLanding = loadable(
  () => import("../pages/masterData/products/ProductsList/LandingPage"),
  loadingKit
)
const Products = loadable(
  () => import("../pages/masterData/products/ProductsList"),
  loadingKit
)
const OffersLanding = loadable(
  () => import("../pages/masterData/offers/OffersList/LandingPage"),
  loadingKit
)
const Offers = loadable(
  () => import("../pages/masterData/offers/OffersList"),
  loadingKit
)
const discountsLanding = loadable(
  () => import("../pages/masterData/discounts/DiscountsList/LandingPage"),
  loadingKit
)
const discounts = loadable(
  () => import("../pages/masterData/discounts/DiscountsList"),
  loadingKit
)

const ProductsGroupsLanding = loadable(
  () => import("../pages/masterData/products/ProductGroupPage/LandingPage"),
  loadingKit
)

const ProductsGroups = loadable(
  () => import("../pages/masterData/products/ProductGroupPage"),
  loadingKit
)

const ProductDataHierarchyLanding = loadable(
  () => import("../pages/masterData/products/ProductHierarchyPage/LandingPage"),
  loadingKit
)
const ProductDataHierarchy = loadable(
  () => import("../pages/masterData/products/ProductHierarchyPage"),
  loadingKit
)

const ProductDataMapping = loadable(
  () => import("../pages/masterData/products/ProductsMapping/ProductMapping"),
  loadingKit
)

const Customers = loadable(
  () => import("../pages/masterData/customers"),
  loadingKit
)

const InventoryLanding = loadable(
  () => import("../pages/masterData/inventoryManagement/LandingPage"),
  loadingKit
)
const Inventory = loadable(
  () => import("../pages/masterData/inventoryManagement/Inventory"),
  loadingKit
)
const InventoryStorageLanding = loadable(
  () => import("../pages/masterData/inventoryStorageManagement/LandingPage"),
  loadingKit
)
const InventoryStorage = loadable(
  () => import("../pages/masterData/inventoryStorageManagement/Inventory"),
  loadingKit
)

const InventoryDetails = loadable(
  () =>
    import(
      "../pages/masterData/inventoryManagement/inventoryDetails/InventoryDetails"
    ),
  loadingKit
)
const InventoryStorageDetails = loadable(
  () =>
    import(
      "../pages/masterData/inventoryStorageManagement/inventoryDetails/InventoryDetails"
    ),
  loadingKit
)

const InventoryAdjustmentsLanding = loadable(
  () =>
    import("../pages/masterData/inventoryManagement/adjustment/LandingPage"),
  loadingKit
)

const InventoryAdjustments = loadable(
  () => import("../pages/masterData/inventoryManagement/adjustment/adjustment"),
  loadingKit
)
const InventoryStockReportLanding = loadable(
  () =>
    import("../pages/masterData/inventoryManagement/stock_report/LandingPage"),
  loadingKit
)
const InventoryStockReport = loadable(
  () =>
    import("../pages/masterData/inventoryManagement/stock_report/adjustment"),
  loadingKit
)
const InventorySuppliersLanding = loadable(
  () =>
    import(
      "../pages/masterData/inventoryManagement/inventorySuppliers/LandingPage"
    ),
  loadingKit
)
const InventorySuppliers = loadable(
  () =>
    import("../pages/masterData/inventoryManagement/inventorySuppliers/index"),
  loadingKit
)
const InventoryBulkProductPurchaseLanding = loadable(
  () =>
    import(
      "../pages/masterData/inventoryManagement/inventoryBulkProductPurchase/LandingPage"
    ),
  loadingKit
)
const InventoryBulkProductPurchase = loadable(
  () =>
    import(
      "../pages/masterData/inventoryManagement/inventoryBulkProductPurchase/inventoryBulkProductPurchase"
    ),
  loadingKit
)
const InventoryPurchaseLanding = loadable(
  () =>
    import(
      "../pages/masterData/inventoryManagement/inventoryPurchase/LandingPage"
    ),
  loadingKit
)
const InventoryPurchase = loadable(
  () =>
    import("../pages/masterData/inventoryManagement/inventoryPurchase/index"),
  loadingKit
)

const InventoryPurchaseCreate = loadable(
  () =>
    import(
      "../pages/masterData/inventoryManagement/inventoryPurchase/PurchaseOrderCreateEdit"
    ),
  loadingKit
)

const InventoryCycleCounts = loadable(
  () =>
    import("../pages/masterData/inventoryManagement/cycleCounts/cycleCounts"),
  loadingKit
)
const InventoryLogs = loadable(
  () => import("../pages/masterData/inventoryManagement/inventoryLogs"),
  loadingKit
)
const InventoryStorageAdjustmentsLanding = loadable(
  () =>
    import(
      "../pages/masterData/inventoryStorageManagement/adjustment/LandingPage"
    ),
  loadingKit
)
const InventoryStorageAdjustments = loadable(
  () =>
    import(
      "../pages/masterData/inventoryStorageManagement/adjustment/adjustment"
    ),
  loadingKit
)

const AdjustmentsDetails = loadable(
  () =>
    import(
      "../pages/masterData/inventoryManagement/adjustment/adjustmentDetails"
    ),
  loadingKit
)
const AdjustmentsStorageDetails = loadable(
  () =>
    import(
      "../pages/masterData/inventoryStorageManagement/adjustment/adjustmentDetails"
    ),
  loadingKit
)

const AdjustmentsInventoryDetails = loadable(
  () =>
    import(
      "../pages/masterData/inventoryManagement/adjustment/inventoryAdjustment"
    ),
  loadingKit
)

const AdjustmentsStorageInventoryDetails = loadable(
  () =>
    import(
      "../pages/masterData/inventoryStorageManagement/adjustment/inventoryAdjustment"
    ),
  loadingKit
)

const CycleCountsInventoryDetails = loadable(
  () =>
    import(
      "../pages/masterData/inventoryManagement/cycleCounts/inventoryCycleCounts"
    ),
  loadingKit
)

const EquipmentList = loadable(
  () => import("../pages/storeEquipment/EquipmentList"),
  loadingKit
)

const Price = loadable(() => import("../pages/masterData/price"), loadingKit)
const Transactions = loadable(() => import("../pages/transactions"), loadingKit)
const TenantTransactionDetails = loadable(
  () => import("../pages/tenantTransactions/transactions"),
  loadingKit
)
const TenantTransactions = loadable(
  () => import("../pages/tenantTransactions"),
  loadingKit
)
const TenantStores = loadable(
  () => import("../pages/tenantTransactions/StoresList"),
  loadingKit
)
const Configuration = loadable(
  () => import("../pages/alerts/configuration/index"),
  loadingKit
)
const AlertsLanding = loadable(
  () => import("../pages/alerts/LandingPage"),
  loadingKit
)
const Alerts = loadable(() => import("../pages/alerts/Alerts"), loadingKit)
const NewAlertLanding = loadable(
  () => import("../pages/alerts/NewAlert/LandingPage"),
  loadingKit
)
const NewAlert = loadable(() => import("../pages/alerts/NewAlert"), loadingKit)
const Monitor = loadable(
  () => import("../pages/alerts/monitor/index"),
  loadingKit
)
const Marketing = loadable(() => import("../pages/marketing"), loadingKit)
const Reports = loadable(
  () => import("../pages/reports/detailedTransactionReport"),
  loadingKit
)
const DetailedTransactionReport = loadable(
  () => import("../pages/reports/detailedTransactionReport"),
  loadingKit
)
const SalesSummaryReportLanding = loadable(
  () => import("../pages/reports/salesSummaryReport/LandingPage"),
  loadingKit
)
const SalesSummaryReport = loadable(
  () => import("../pages/reports/salesSummaryReport"),
  loadingKit
)

const InventoryReportLanding = loadable(
  () => import("../pages/reports/inventoryReport/LandingPage"),
  loadingKit
)
const InventoryReport = loadable(
  () => import("../pages/reports/inventoryReport/inventoryReport"),
  loadingKit
)
const InventoryLogReport = loadable(
  () => import("../pages/reports/inventoryLogReport"),
  loadingKit
)
const User = loadable(() => import("../pages/userManagement/users"), loadingKit)
const TaxProvider = loadable(
  () => import("../pages/configuration/taxProvider/TaxProvider"),
  loadingKit
)
const PaymentIntegration = loadable(
  () => import("../pages/configuration/PaymentIntegration"),
  loadingKit
)
const AuditLog = loadable(
  () => import("../pages/logviewer/auditLogs/AuditLog"),
  loadingKit
)
const ApplicationLog = loadable(
  () => import("../pages/logviewer/applicationlogs/ApplicationLog"),
  loadingKit
)
const RolePermission = loadable(
  () =>
    import("../pages/userManagement/rolePermission/rolePermissionList/index"),
  loadingKit
)
const Permission = loadable(
  () => import("../pages/userManagement/permission/index"),
  loadingKit
)
const SubsaasPermission = loadable(
  () => import("../pages/userManagement/SubsaasPermission/index"),
  loadingKit
)
const TenantPermission = loadable(
  () => import("../pages/userManagement/tenantPermission/index"),
  loadingKit
)
const TenantPermissionLanding = loadable(
  () => import("../pages/userManagement/tenantPermission/LandingPage"),
  loadingKit
)

const RolePermissionDetails = loadable(
  () => import("../pages/userManagement/rolePermission/index"),
  loadingKit
)
const subsaasRolePermissionDetails = loadable(
  () => import("../pages/userManagement/subsaasrolePermission/index"),
  loadingKit
)
const tenantRolePermissionDetails = loadable(
  () => import("../pages/userManagement/tenantrolePermission/index"),
  loadingKit
)
const System = loadable(() => import("../pages/system"), loadingKit)
const EditProfile = loadable(() => import("../pages/editProfile"), loadingKit)
const Settings = loadable(() => import("../pages/settings"), loadingKit)
const PaymentGatewayConfigLanding = loadable(
  () => import("../pages/settings/PaymentGatewayConfig/LandingPage"),
  loadingKit
)
const PaymentGatewayConfig = loadable(
  () => import("../pages/settings/PaymentGatewayConfig/PaymentGatewayConfig"),
  loadingKit
)
const Help = loadable(() => import("../pages/help"), loadingKit)
const Support = loadable(() => import("../pages/support"), loadingKit)
const Privacy = loadable(() => import("../pages/privacy"), loadingKit)
const StoreEquipment = loadable(
  () => import("../pages/storeEquipment"),
  loadingKit
)
const StoreEquipmentDetails = loadable(
  () => import("../pages/storeEquipment/EquipmentList/StoreEquipmentDetails"),
  loadingKit
)

const LiveMonitoring = loadable(
  () => import("../pages/liveMonitoring"),
  loadingKit
)

const TermsOfService = loadable(
  () => import("../pages/termsOfService"),
  loadingKit
)
const CreateLocation = loadable(() =>
  import("../pages/masterData/locations/CreateLocations")
)
const GroupLocationsList = loadable(() =>
  import("../pages/masterData/locations/GroupLocation/LocationGroupCreatePage")
)
const ProductGroupCreate = loadable(() =>
  import("../pages/masterData/products/createGroupModel/ProductGroupCreatePage")
)
const LocationDetailedPage = loadable(() =>
  import("../pages/masterData/locations/LocationDetailedPage/index")
)

const LocationTabLandingPage = loadable(() =>
  import(
    "../pages/masterData/locations/LocationDetailedPage/LocationLandingPage"
  )
)
const LocationTabLandingPagePurchase = loadable(() =>
  import(
    "../pages/masterData/inventoryManagement/inventoryBulkProductPurchase/LocationLandingPage.jsx"
  )
)
const PurchaseViewHistory = loadable(() =>
  import(
    "../pages/masterData/inventoryManagement/inventoryBulkProductPurchase/ViewHistory.jsx"
  )
)
const PurchaseViewHistoryDetail = loadable(() =>
  import(
    "../pages/masterData/inventoryManagement/inventoryBulkProductPurchase/UploadHistoryDetail.jsx"
  )
)

const StorageLoadingPage = loadable(() =>
  import(
    "../pages/masterData/locationProductStorage/createUpdateStorage/StorageLandingPage"
  )
)

const CustomerDetailedPage = loadable(() =>
  import("../pages/masterData/customers/CustomerDetailedPage")
)

const PriceDetailedPage = loadable(() =>
  import("../pages/masterData/price/priceDetailedPage")
)

const InventoryDetailedPage = loadable(() =>
  import("../pages/masterData/inventory/InventoryDetailedPage")
)

const LocationGroupDetailedPage = loadable(() =>
  import(
    "../pages/masterData/locations/GroupLocation/LocationGroupDetailedPage"
  )
)

const ProductGroupDetailedPage = loadable(() =>
  import("../pages/masterData/products/GroupDetail/ProductGroupDetailedPage")
)

const AddNewAddress = loadable(() =>
  import("../pages/masterData/customers/AddNewAddress")
)

const CreateCustomer = loadable(() =>
  import("../pages/masterData/customers/CreateCustomers")
)
const CreateInventory = loadable(() =>
  import("../pages/masterData/inventory/CreateInventory")
)
const CreateEquipment = loadable(() =>
  import("../pages/storeEquipment/CreateEquipment")
)
const CreatePrice = loadable(() =>
  import("../pages/masterData/price/CreatePrice")
)
const CreateProduct = loadable(
  () => import("../pages/masterData/products/ProductCreatePage") //MVP 2
)

const EditProduct = loadable(() =>
  import("../pages/masterData/products/ProductDetailedPage/ProductDetailedPage")
)

const CreateProductGroup = loadable(() =>
  import("../pages/masterData/products/GroupDetail")
)
const Status = loadable(() => import("../pages/status"), loadingKit)

const EditOrderDetails = loadable(() =>
  import("../pages/transactions/EditOrder/EditOrder")
)

const EditTenantTransactionsOrderDetails = loadable(() =>
  import(
    "../pages/transactionBrowser/transactionBrowserDetails/transactionBrowserDetails"
  )
)

const TransactionBrowserDetails = loadable(
  import(
    "../pages/transactionBrowser/transactionBrowserDetails/transactionBrowserDetails"
  )
)

const EditTurnstileDetails = loadable(() =>
  import("../pages/smartDeviceConfig/turnstile/editTurnstile/index")
)

const EditGondolaDetails = loadable(() =>
  import("../pages/smartDeviceConfig/gondola/editGondola/index")
)

const DeviceMgmtLandingPage = loadable(() =>
  import("../pages/smartDeviceConfig/DeviceManagement/index")
)

const EditDeviceMgmtPage = loadable(() =>
  import("../pages/smartDeviceConfig/DeviceManagement/editDevice/index")
)

const CreateDeviceMgmtPage = loadable(() =>
  import("../pages/smartDeviceConfig/DeviceManagement/createDevice/index")
)

const EditCameraDetails = loadable(() =>
  import("../pages/smartDeviceConfig/camera/editCamera/index")
)
const EditSmartShelfDetails = loadable(() =>
  import("../pages/smartDeviceConfig/smartShelf/editSmartShelf/index")
)

const CreateTurnstileDetails = loadable(() =>
  import("../pages/smartDeviceConfig/turnstile/createtuenstile/index")
)

const CreateSmartShelfDetails = loadable(() =>
  import("../pages/smartDeviceConfig/smartShelf/createSmartShelf/index")
)

const CreateCameraDetails = loadable(() =>
  import("../pages/smartDeviceConfig/camera/createCamera/index")
)

const CreateGondolaDetails = loadable(() =>
  import("../pages/smartDeviceConfig/gondola/createGondola/index")
)

const CreateFSCameraDetails = loadable(() =>
  import("../pages/smartDeviceConfig/cameraFS/createCamera/index")
)

const EditFSCameraDetails = loadable(() =>
  import("../pages/smartDeviceConfig/cameraFS/editCamera/index")
)

const CreateFSEdgeDeviceDetails = loadable(() =>
  import("../pages/smartDeviceConfig/edgeDeviceFS/createEdgeDevice/index")
)

const EditFSEdgeDeviceDetails = loadable(() =>
  import("../pages/smartDeviceConfig/edgeDeviceFS/editEdgeDevice/index")
)

const Tenant = loadable(() => import("../pages/tenant/index"), loadingKit)

const createVendors = loadable(() =>
  import("../pages/masterData/vendors/createUpdateVendors/index")
)

const updateVendors = loadable(() =>
  import("../pages/masterData/vendors/createUpdateVendors/VendorLandingPage")
)

const CreateEditUser = loadable(() =>
  import("../pages/userManagement/users/userCreateEdit/index")
)
const CreateEditTax = loadable(() =>
  import("../pages/configuration/taxProvider/taxCreate/TaxCreateEdit")
)

const TenantCreateEdit = loadable(() =>
  import("../pages/tenant/tenantCreateEdit/TenantCreateEdit")
)

const MonitoringProducts = loadable(
  () => import("../pages/liveMonitoring/products/ProductsList"),
  loadingKit
)

const EditLiveMonitoringProduct = loadable(() =>
  import("../pages/liveMonitoring/products/ProductDetailedPage")
)

const CreateEditPaymentConfig = loadable(() =>
  import("../pages/settings/PaymentGatewayConfig/MultiplePaymentCreateEdit")
)

const RemoteUnlockConfig = loadable(() => import("../pages/remoteUnlock/index"))

const TransactionBrowser = loadable(() =>
  import("../pages/transactionBrowser/tenantDetails")
)

const TransactionBrowserAll = loadable(() =>
  import("../pages/transactionBrowser/transactionBrowser")
)
const CreateEditPlatformAccountConfig = loadable(() =>
  import("../pages/configuration/PaymentIntegration/MultiplePlatformCreateEdit")
)

const EntryorExitGateLanding = loadable(
  () => import("../pages/smartDeviceConfig/entryorexitgate/LandingPage"),
  loadingKit
)
const EntryorExitGate = loadable(
  () => import("../pages/smartDeviceConfig/entryorexitgate/index"),
  loadingKit
)

const CreateEntryorExitGateDetails = loadable(() =>
  import(
    "../pages/smartDeviceConfig/entryorexitgate/createEntryorexitgate/index"
  )
)
const EditEntryorExitGateDetails = loadable(() =>
  import("../pages/smartDeviceConfig/entryorexitgate/editEntryorexitgate/index")
)

const PageComponentLibrary = {
  EntryorExitGateLanding,
  EntryorExitGate,
  CreateEntryorExitGateDetails,
  EditEntryorExitGateDetails,
  SpacePlanning,
  FrictionlessStore,
  ForgetPassword,
  CameraFS,
  EdgeDeviceFS,
  SpacePlanningList,
  SpacePlanningListTenant,
  GondolaLanding,
  Gondola,
  Planogram,
  PlanogramLanding,
  DeviceConfig,
  CameraLanding,
  Camera,
  SmartshelfLanding,
  Smartshelf,
  Turnstile,
  StoreConfig,
  PaymentReadersLanding,
  PaymentReaders,
  StoreDevicesLanding,
  StoreDevices,
  inStoreDisplay,
  SignIn,
  SignUp,
  ResetPassword,
  Page404,
  Page500,
  Page403,
  Dashboard,
  Countries,
  USStates,
  Currencies,
  Gender,
  Digitshelf,
  CanadianProvincesList,
  EquipmentList,
  Languages,
  UnitsOfMeasure,
  BarcodeTypes,
  Tax,
  Vendors,
  VendorsLanding,
  LocationsProductStorage,
  LocationsProductStorageLanding,
  CreateUpdateStorage,
  Locations,
  LocationsLanding,
  Inventory,
  InventoryLanding,
  InventoryStorageLanding,
  InventoryStorage,
  InventoryDetails,
  InventoryStorageDetails,
  InventoryAdjustments,
  InventoryAdjustmentsLanding,
  InventoryStockReport,
  InventoryStockReportLanding,
  InventoryBulkProductPurchase,
  InventoryBulkProductPurchaseLanding,
  InventorySuppliersLanding,
  InventorySuppliers,
  InventoryPurchase,
  InventoryPurchaseLanding,
  InventoryPurchaseCreate,
  InventoryCycleCounts,
  InventoryLogs,
  InventoryStorageAdjustments,
  InventoryStorageAdjustmentsLanding,
  AdjustmentsDetails,
  AdjustmentsStorageDetails,
  AdjustmentsInventoryDetails,
  AdjustmentsStorageInventoryDetails,
  CycleCountsInventoryDetails,
  Products,
  ProductsLanding,
  OffersLanding,
  Offers,
  discounts,
  discountsLanding,
  Customers,
  Transactions,
  TenantTransactions,
  TenantTransactionDetails,
  TenantStores,
  LiveMonitoring,
  Marketing,
  Reports,
  Alerts,
  AlertsLanding,
  NewAlert,
  NewAlertLanding,
  Configuration,
  Monitor,
  User,
  TaxProvider,
  AuditLog,
  ApplicationLog,
  RolePermission,
  Permission,
  SubsaasPermission,
  TenantPermission,
  TenantPermissionLanding,
  RolePermissionDetails,
  subsaasRolePermissionDetails,
  tenantRolePermissionDetails,
  LocationTabLandingPage,
  LocationTabLandingPagePurchase,
  PurchaseViewHistory,
  PurchaseViewHistoryDetail,
  StorageLoadingPage,
  System,
  EditProfile,
  Settings,
  Help,
  Support,
  Privacy,
  TermsOfService,
  CreateLocation,
  CreateCustomer,
  CreateProduct,
  EditProduct,
  LocationDetailedPage,
  LocationGroupDetailedPage,
  ConfigurePos,
  CreateNewPos,
  PosDetailedScreen,
  ProductGroupDetailedPage,
  CustomerDetailedPage,
  PriceDetailedPage,
  InventoryDetailedPage,
  AddNewAddress,
  Status,
  Price,
  CreateInventory,
  CreatePrice,
  GroupLocationsList,
  CreateProductGroup,
  StoreEquipment,
  StoreEquipmentDetails,
  CreateEquipment,
  EditOrderDetails,
  EditTurnstileDetails,

  EditGondolaDetails,
  EditCameraDetails,
  EditSmartShelfDetails,
  CreateTurnstileDetails,

  CreateSmartShelfDetails,
  CreateCameraDetails,
  CreateFSCameraDetails,
  EditFSCameraDetails,
  CreateFSEdgeDeviceDetails,
  EditFSEdgeDeviceDetails,
  CreateGondolaDetails,
  Groups,
  GroupsLanding,
  HierarchyLanding,
  Hierarchy,
  ProductsGroups,
  ProductsGroupsLanding,
  ProductGroupCreate,
  ProductDataHierarchy,
  ProductDataHierarchyLanding,
  ProductDataMapping,
  HierarchyMappingLanding,
  HierarchyMapping,
  ProductAttributeLanding,
  ProductAttribute,
  Tenant,
  createVendors,
  updateVendors,
  CreateEditUser,
  CreateEditTax,
  TenantCreateEdit,
  SassDashboard,
  PlanogramDetails,
  MonitoringProducts,
  EditLiveMonitoringProduct,
  DeviceMgmtLandingPage,
  EditDeviceMgmtPage,
  CreateDeviceMgmtPage,
  ProfileUpdate,
  EmployeeDetails,
  EditTenantTransactionsOrderDetails,
  TransactionBrowserDetails,
  PaymentGatewayConfig,
  PaymentGatewayConfigLanding,
  SalesSummaryReport,
  SalesSummaryReportLanding,
  InventoryReport,
  InventoryReportLanding,
  InventoryLogReport,
  DetailedTransactionReport,
  CreateEditPaymentConfig,
  RemoteUnlockConfig,
  TransactionBrowser,
  TransactionBrowserAll,
  PaymentGateWayContent,
  StoreTypeContent,
  ReceiptQR,
  PaymentIntegration,
  CreateEditPlatformAccountConfig,
}
export { PageComponentLibrary }
export default PageComponentLibrary
